// TODO - Remove the logic for stepIndex={0} & islastStep={true}. Since for user created recipes, we only have one step, so this islastStep prop will always be true, but will have to create a generalized solution if in case there are more than 1 step

import { useContext, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { useMutation } from "@apollo/client";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { MODIFY_RECIPE_DATA } from "../app/graphql/mutations";
import { setCreateSubstepOpen, setEditStepView, setRecipeData } from "../app/recipeCreation/createRecipe.slice";
import { setRecipe } from "../app/recipePage/recipePage.slice";
import { useAppDispatch, useAppSelector } from "../app/store/hooks"
import LoadingUpAnimation from "../components/LoadingUpAnimation";
import CreateSubstep from "../components/recipeCreation/recipeSteps/createSubstep";
import StepsHeader from "../components/recipeCreation/stepsHeader"
import StepsView from "../components/recipeCreation/stepView";
import useCheckHistory from "../hooks/useCheckHistory";
import cookingTimeCalculation from "../utils/cookingTimeUtil";
import { ErrorManagementContext } from "../utils/errorManagement/ErrorManagementProvider";
import { logEvents } from "../utils/logging";
import { recipeE3TransformerQL2FS } from "../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import useRecipeFromDB from "../utils/RecipeBackEnd/loadRecipe";
import styles from "./recipeCreationSteps.module.css";

const RecipeCreationSteps = () => {
    const { recipeId: urlRecipeId } = useParams<any>();
    const { loading } = useRecipeFromDB(urlRecipeId);
    const recipe = useAppSelector((state) => state.recipePage.recipe)
    const recipeData = useAppSelector((state) => state.recipeCreation.recipeData)
    const editStepView = useAppSelector((state) => state.recipeCreation.editStepView)
    const substeps = useMemo(() => recipe?.steps[0]?.subSteps, [recipe]);
    const dispatch = useAppDispatch();
    const [modifyRecipeData] = useMutation(MODIFY_RECIPE_DATA)
    const { cookClubLog } = useContext(ErrorManagementContext)
    const createSubstepOpen = useAppSelector((state) => state.recipeCreation.createSubstepOpen)
    const [mobileGeneratedRecipeIsUpdating, setMobileGeneratedRecipeIsUpdating] = useState<boolean>(false)
    const user = useAppSelector((state) => state.main.user);
    const device = useAppSelector((state) => state.main.device);
    const goBackOrRedirect = useCheckHistory();

    const onClickBack = () => {
        goBackOrRedirect('/');
        dispatch(setEditStepView(false))
    }
    const onSave = async () => {
        try {
            logEvents('null', "APP_RECIPE_SAVED", {
                userId: user?.id,
                deviceId: device?.displayName ?? device?._id,
                recipeId: recipe?.id,
            })
            const cookingTimeCalc = cookingTimeCalculation(substeps);
            const cookingTime = Math.ceil(cookingTimeCalc / 60);
            const defaultRecipeVar = recipeData.Recipe_Variations.find((recipe) => recipe.default === true)
            const newDefaultRecipeVar = { ...defaultRecipeVar, cooking_time: cookingTime }

            const newRecipeData = {
                ...recipeData,
                Recipe_Variations: [newDefaultRecipeVar]
            }
            setMobileGeneratedRecipeIsUpdating(true)

            const { data } = await modifyRecipeData({
                variables: { recipeData: newRecipeData, recipeId: newRecipeData.id }
            })
            setMobileGeneratedRecipeIsUpdating(false)
            dispatch(setRecipeData(data.update_User_Generated_Recipes.returning[0].recipeData))
            dispatch(setRecipe({ recipe: recipeE3TransformerQL2FS(data.update_User_Generated_Recipes.returning[0].recipeData) }))

        }
        catch (err) {
            console.log(err)
            cookClubLog(`Could not save. Please try again.`, "", {}, { ui: { type: "info" }, browserConsole: true })
        }
        dispatch(setEditStepView(false))
    }
    if (loading)
        return (<LoadingUpAnimation />)
    return (
        <Box className={editStepView ? styles.steps_header_container_edit_view : styles.steps_header_container}>
            <StepsHeader buttonLoading={mobileGeneratedRecipeIsUpdating} buttonText="Save" onButtonClick={onSave}
                onClickBack={onClickBack} text={recipe?.metadata?.name ?? ''} />
            {substeps && <StepsView createdBy={recipeData.created_by} createdSource={recipeData.created_source} islastStep
                recipeId={recipe?.id} stepId={recipe?.steps[0]?.id ?? null} stepIndex={0}
                substeps={substeps} />}
            {editStepView && <Button className={styles.create_button_dialog} onClick={() => dispatch(setCreateSubstepOpen(true))}>
                <Typography variant='captionparalell'>+ Add Step</Typography>
            </Button>}
            {createSubstepOpen && <CreateSubstep />}
        </Box >
    )
}

export default RecipeCreationSteps